import styled, {keyframes} from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  a {
    text-align: end;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 900;
    color: #008cff;
    cursor: pointer;
  }
`;

export const Title = styled.h2`
  font-style: normal;
  font-weight: 900;
  font-size: 26px;
  line-height: 32px;
  color: #000000;
`;

export const Summary = styled.p`
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 32px;
`;
const shine = keyframes`
  0% {
    transform: translateX(-100%) scaleX(1.2);
  }
  100% {
    transform: translateX(100%) scaleX(1.2);
  }
`;

export const GstBlinker = styled.div`
  display: flex;
  width: 836px;
  padding: 14px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid #e4a37d;
  margin-bottom: 32px;
  background: linear-gradient(-135deg, #ffe9dd 0%, #ffffff 70%);
  border-radius: 12px;
  border: 1px solid #e4a37d;
  position: relative;
  overflow: hidden; /* Ensures shine stays inside */

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 90%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: ${shine} 3s ease-in-out 3;
    pointer-events: none;
    border-radius: 12px;
  }
`;
export const GstBlinkerText = styled.span`
  align-self: stretch;
  color: #000;

  /* Heading/Base 1 */
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px; /* 125% */
`;

export const GstBlinkerSubText = styled.span`
  align-self: stretch;
  color: #4a4a4a;

  /* Labels/Base(W1) */
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  b {
    color: var(--Content-High-Emphasis, #000);

    /* Labels/Base(W2) */
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }
`;
export const GstBlinkerIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
